/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UsersListState = { dirty: boolean };
const initialState: UsersListState = { dirty: false };

const usersListSlice = createSlice({
  name: "usersList",
  initialState,
  reducers: {
    markUsersDirty: (s, a: PayloadAction<boolean | undefined>) => {
      s.dirty = a.payload ?? true;
    },
    clearUsersDirty: (s) => { s.dirty = false; },
  },
});

export const { markUsersDirty, clearUsersDirty } = usersListSlice.actions;
export const selectUsersDirty = (s: any) => (s.usersList?.dirty ?? false);
export default usersListSlice.reducer;
